/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./vardhana-wallet.component.scss.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./vardhana-wallet.component";
var styles_VardhanaWalletComponent = [i0.styles];
var RenderType_VardhanaWalletComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_VardhanaWalletComponent, data: {} });
export { RenderType_VardhanaWalletComponent as RenderType_VardhanaWalletComponent };
export function View_VardhanaWalletComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_VardhanaWalletComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-vardhana-wallet", [], null, null, null, View_VardhanaWalletComponent_0, RenderType_VardhanaWalletComponent)), i1.ɵdid(1, 114688, null, 0, i2.VardhanaWalletComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var VardhanaWalletComponentNgFactory = i1.ɵccf("app-vardhana-wallet", i2.VardhanaWalletComponent, View_VardhanaWalletComponent_Host_0, {}, {}, []);
export { VardhanaWalletComponentNgFactory as VardhanaWalletComponentNgFactory };
